module.exports = __webpack_public_path__ + "static/img/bg_img_nothing@2x.4b6a59a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/default/bg_img_nothing@2x.png
// module id = ghBP
// module chunks = 1